export const GTM_PLATFORM_VERSION = 4;

// Domains with a first-party (Akamai-proxied) GTM path; everything else (woonenergie.nl,
// eneco.co.uk, eneco.be, local/preview hosts, ...) keeps loading GTM directly from
// googletagmanager.com. Domain-based (not label/businessUnit-based) because the gb-eneco-main
// container sets businessUnit to 'nl' and label to 'eneco' despite serving eneco.co.uk.
export const FIRST_PARTY_GTM_HOST_SUFFIXES = ['eneco.nl', 'oxxio.nl'] as const;
